import Vue from 'vue'
import Router from 'vue-router'
// import RouteView from '@/layouts/RouteView'
// import MenuView from '@/layouts/MenuView'
// import Login from '@/pages/login/Login'
// import Video from '@/pages/video/index'
// import NotFound from '@/pages/404'
// import personal from '@/pages/personal/personal'
// import list from '@/pages/homework/assignHomework/list'
// import add from '@/pages/homework/assignHomework/add'
// import homeworkList from '@/pages/homework/assignHomework/homeworkList'
// import studentWorkDetail from '@/pages/homework/assignHomework/studentWorkDetail'
// import correctList from '@/pages/homework/correctHomework/list'
// import correctByPeople from '@/pages/homework/correctHomework/correctByPeople'
// import correctDetailsByP from '@/pages/homework/correctHomework/correctDetailsByP'
// import correctDetailsByQ from '@/pages/homework/correctHomework/correctDetailsByQ'
// import viewHomeworkList from '@/pages/homework/correctHomework/viewHomeworkList'
// import classList from '@/pages/educationAdmin/class/list'
// import studentList from '@/pages/educationAdmin/student/index'
// import teacherList from '@/pages/educationAdmin/teacher/index'
// import teacherAssistantList from '@/pages/educationAdmin/teacherAssistant/index'
// import schoolInfoList from '@/pages/educationAdmin/schoolInfo/list'
// import viewHomework from '@/pages/homework/correctHomework/viewHomework'
// import publishedWork from '@/pages/homework/assignHomework/components/studentListIssued'

Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default new Router({
  base: 'osca/web', // 发布到nginx此配置需要打开 非nginx服务器不需要打开此配置
  routes: [
    {
      path: '/',
      name: '首页',
      component: ()=> import ('@/pages/home/index'),
      invisible: true
    },
    {
      path: '/login',
      name: '登录页',
      component: ()=> import ('@/pages/login/Login'),
      invisible: true
    },
    {
      path: '/404',
      name: '404',
      component: ()=>import('@/pages/404'),
      invisible: true
    },
    {
      path: '/personal',
      name: '个人资料',
      component: ()=>import('@/pages/personal/personal')
    },
    {
      path: '/studentPrompt',
      name: '学生登录PC',
      component: ()=> import ('@/pages/studentPrompt/index'),
      invisible: true
    },
    {
      path: '/teacherPrompt',
      name: '教师助教无班级登录PC',
      component: ()=> import ('@/pages/teacherPrompt/index'),
      invisible: true
    },
    {
      path: '/video',
      name: '视频播放',
      component: ()=>import('@/pages/video/index'),
      invisible: true
    },
    {
      path:'/paperview',
      name:'试卷预览',
      component:()=> import ('@/pages/structurePapers/component/paper1.vue'),
      invisible: true
      
    },
    {
      path:'/answerview',
      name:'答案预览',
      component:()=>import('@/pages/structurePapers/component/answerview.vue'),
      invisible: true
    }
    // ,
    // {
    //   path: '/',
    //   name: '首页',
    //   component: MenuView,
    //   redirect: '/login',
    //   invisible: true,
    //   children: [
    //     {
    //       path: '/homework',
    //       name: '作业',
    //       component: RouteView,
    //       icon: 'iconfont iconHomeworkDefault',
    //       children: [
    //         {
    //           path: '/homework/assignHomework',
    //           name: '布置作业',
    //           component: list,
    //         },
    //         {
    //           path: 'assignHomework/add',
    //           name: 'AssignHomeworkAdd',
    //           component: add,
    //           meta: {
    //             title: '新建',
    //             keepAlive: false,
    //             // activeMenu: '/homework/assignHomework',
    //             // noCache: true,
    //             // breadNUm: 3,
    //             // breadList: [{
    //             //   path: '/homework/assignHomework',
    //             //   meta: { title: '布置作业' }
    //             // }],
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'assignHomework/homeworkList',
    //           name: 'AssignHomeworkList',
    //           component: homeworkList,
    //           meta: {
    //             title: '作业列表',
    //             // activeMenu: '/homework/assignHomework',
    //             // noCache: true,
    //             // breadNUm: 3,
    //             // breadList: [{
    //             //   path: '/homework/assignHomework',
    //             //   meta: { title: '布置作业' }
    //             // }],
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'assignHomework/detail',
    //           name: 'AssignHomeworkList',
    //           component: studentWorkDetail,
    //           meta: {
    //             title: '学生作业详情',
    //             // activeMenu: '/homework/assignHomework',
    //             // noCache: true,
    //             // breadNUm: 3,
    //             // breadList: [{
    //             //   path: '/homework/assignHomework',
    //             //   meta: { title: '布置作业' }
    //             // }],
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: '/homework/correctHomework',
    //           name: '批改作业',
    //           component: correctList
    //         },
    //         {
    //           path: '/homework/published',
    //           name: 'viewHomework',
    //           component: publishedWork,
    //           meta: {
    //             title: '已发布',
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'correctHomework/correctByPeople',
    //           name: 'correctByPeople',
    //           component: correctByPeople,
    //           meta: {
    //             title: '全部批改',
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'correctHomework/correctDetailsByP',
    //           name: 'correctDetailsByP',
    //           component: correctDetailsByP,
    //           meta: {
    //             title: '批改作业详情_按人批改',
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'correctHomework/correctDetailsByQ',
    //           name: 'correctDetailsByQ',
    //           component: correctDetailsByQ,
    //           meta: {
    //             title: '批改作业详情_按题批改',
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'correctHomework/viewHomeworkList',
    //           name: 'viewHomeworkList',
    //           component: viewHomeworkList,
    //           meta: {
    //             title: '查看作业',
    //             isHidden: true
    //           }
    //         },
    //         {
    //           path: 'correctHomework/viewHomework',
    //           name: 'viewHomeworkDetail',
    //           component: viewHomework,
    //           meta: {
    //             title: '查看作业详情',
    //             isHidden: true
    //           }
    //         }
    //       ]
    //     },
    //     {
    //       path: '/educationAdmin/class',
    //       name: '班级管理',
    //       icon: 'iconfont iconbanjiguanli',
    //       component: classList
    //     },
    //     {
    //       path: '/educationAdmin/student',
    //       name: '学生管理',
    //       icon: 'iconfont iconxueshengguanli',
    //       component: studentList
    //     },
    //     {
    //       path: '/educationAdmin/teacher',
    //       name: '教师管理',
    //       icon: 'iconfont iconjiaoshiguanli',
    //       component: teacherList
    //     },
    //     {
    //       path: '/educationAdmin/teacherAssistant',
    //       name: '助教管理',
    //       icon: 'iconfont iconzhuliguanli',
    //       component: teacherAssistantList
    //     },
    //     {
    //       path: '/educationAdmin/schoolInfo',
    //       name: '院校信息',
    //       icon: 'iconfont iconyuanxiaoxinxi',
    //       component: schoolInfoList
    //     }
    //   ]
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/lazy.js